import { createAction, props } from '@ngrx/store';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { ExpenseSkeleton, PagedExpenseAudit } from '../../+models/expense.audit.model';

export const ResetExpense = createAction('[SharedAudit Expense] Reset');

export const LoadExpenseCategoryTypes = createAction(
  '[SharedAudit Expense] Load ExpenseCategory Types'
);

export const ExpenseCategoryTypesLoaded = createAction(
  '[SharedAudit Expense] ExpenseCategory Types Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const ExpenseCategoryTypesLoadError = createAction(
  '[SharedAudit Expense] ExpenseCategory Types Load Error',
  props<{ err: any }>()
);

export const LoadExpenseSkeleton = createAction('[SharedAudit Expense] Load Expense Skeleton');

export const LoadDeletedExpenseSkeletons = createAction(
  '[SharedAudit Expense] Load Deleted Expense Skeletons'
);

export const ExpenseSkeletonLoaded = createAction(
  '[SharedAudit Expense] Expense Skeleton Loaded',
  props<{ payload: ExpenseSkeleton }>()
);

export const ExpenseSkeletonLoadError = createAction(
  '[SharedAudit Expense] Expense Skeleton Load Error',
  props<{ err: any }>()
);

export const DeletedExpenseSkeletonsLoaded = createAction(
  '[SharedAudit Expense] Deleted Expense Skeletons Loaded',
  props<{ payload: ExpenseSkeleton[] }>()
);

export const DeletedExpenseSkeletonsLoadError = createAction(
  '[SharedAudit Expense] Deleted Expense Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadExpenseAudit = createAction(
  '[SharedAudit Expense] Load Expense Audit',
  props<{ expenseId: number }>()
);

export const LoadNextPageExpenseAudit = createAction(
  '[SharedAudit Expense] Load NextPage Expense Audit',
  props<{ expenseId: number }>()
);

export const ExpenseAuditLoaded = createAction(
  '[SharedAudit Expense] Expense Audit Loaded',
  props<{ expenseId: number; readonly audits: PagedExpenseAudit }>()
);

export const ExpenseAuditLoadError = createAction(
  '[SharedAudit Expense] Expense Audit Load Error',
  props<{ err: any }>()
);
